<template>
  <v-carousel :show-arrows="true">
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
    ></v-carousel-item>
  </v-carousel>
</template>

<script>
  export default {
    data () {
      return {
        items: [
          {
            src: 'img/benefit_mobility.jpg',
          },
          {
            src: 'img/benefit_commercial.jpg',
          },
          {
            src: 'img/benefit_hotel.jpg',
          },
        ],
      }
    },
  }
</script>
